// src/fleet-stats/components/TrendCards.jsx
import React from "react";
import { C, CARD_BG, CARD_BORDER } from "../constants.js";
import { fmtNum, fmtInt, fmtChangePct } from "../utils/format.js";

function TrendCard({ label, current, previous, changePct, unit = "", fmt = fmtNum, context = null }) {
    const hasChange = changePct !== null && previous > 0;
    const isUp = changePct >= 0;
    const changeColor = isUp ? C.neonGreen : "#ff5f5f";
    const arrow = isUp ? "↑" : "↓";

    return (
        <div
            className="flex-1 min-w-[160px] rounded-2xl px-4 py-3"
            style={{ backgroundColor: CARD_BG, border: CARD_BORDER }}
        >
            <div className="text-xs uppercase tracking-wide" style={{ color: C.grey2 }}>{label}</div>
            <div className="text-2xl font-semibold mt-1" style={{ color: C.offWhite }}>
                {fmt(current)}{unit && <span className="text-base font-normal ml-1" style={{ color: C.grey1 }}>{unit}</span>}
            </div>
            {hasChange ? (
                <div className="flex items-center gap-1.5 mt-1">
                    <span className="text-xs font-bold" style={{ color: changeColor }}>
                        {arrow} {fmtChangePct(changePct)}
                    </span>
                    <span className="text-xs" style={{ color: C.grey2 }}>
                        vs prev {fmt(previous)}{unit}
                    </span>
                </div>
            ) : (
                <div className="text-xs mt-1" style={{ color: C.grey2 }}>No previous data</div>
            )}
            {context && <div className="text-xs mt-0.5" style={{ color: C.grey2 }}>{context}</div>}
        </div>
    );
}

export function TrendCards({ trends, dateFrom, dateTo }) {
    if (!trends) return null;

    return (
        <div className="mb-6">
            {/* Explicit window label — this layer follows the date filter, unlike the board above */}
            <div className="text-xs mb-2" style={{ color: C.grey2 }}>
                Selected period <span style={{ color: C.grey1 }}>{dateFrom} → {dateTo}</span> vs previous <span style={{ color: C.grey1 }}>{trends.prevFrom} → {trends.prevTo}</span>
            </div>
            <div className="flex flex-wrap gap-3">
                <TrendCard
                    label="Distance"
                    current={trends.km.current}
                    previous={trends.km.previous}
                    changePct={trends.km.changePct}
                    unit="km"
                />
                <TrendCard
                    label="Driving time"
                    current={trends.hours.current}
                    previous={trends.hours.previous}
                    changePct={trends.hours.changePct}
                    unit="h"
                />
                <TrendCard
                    label="Total uptime"
                    current={trends.uptime.current}
                    previous={trends.uptime.previous}
                    changePct={trends.uptime.changePct}
                    unit="h"
                    context={`across ${fmtInt(trends.activeRobots.current)} active robots`}
                />
            </div>
        </div>
    );
}
